import * as React from 'react';

export const TableContext = React.createContext({});
